import React from 'react';
import AppRoutes from './routes';
import ServiceWorkerUpdateNotification from './components/ServiceWorkerUpdateNotification';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from './toast/Toaster';
import './App.css';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AppRoutes />
      <ServiceWorkerUpdateNotification />
      {/* v2 トースト表示コンテナ (旧 antd message/notification の置換) */}
      <Toaster />
    </ErrorBoundary>
  );
};

export default App;
